/* @flow */
import React from 'react';
import Link from 'components/Link.jsx';
import Form from 'components/Form.jsx';
import enumerate from 'lib/enumerate';
import Button from 'components/Button.jsx';
import Fieldset from 'components/Fieldset.jsx';
import FormInput from 'components/FormInput.jsx';
import UserActions from 'user/UserActions';
import LinkConstants from 'constants/LinkConstants';
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/ResetPasswordPage.scss';

const STATUS = enumerate([
  'pending',
  'failure',
]);

class ResetPasswordPage extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  state = {
    status: STATUS.pending,
    canSubmit: false,
  };

  disableButton = () => {
    if (this.state.canSubmit) {
      this.setState({ canSubmit: false });
    }
  };

  enableButton = () => {
    if (!this.state.canSubmit) {
      this.setState({ canSubmit: true });
    }
  };

  submit = (value: {password: string}) => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Your password has been changed');
      this.context.router.push('/classes');
    };

    const onFailure = () => {
      this.setState({ status: STATUS.failure });
    };

    UserActions
      .resetPassword(value.password)
      .then(onSuccess, onFailure);
  };

  renderFailure = () => {
    return (
      <div className="ResetPasswordPage-Failure">
        <h4 className="ResetPasswordPage-Title">
          Your link has expired.
        </h4>

        <p>
          For security reason the reset link sent via email
          is only valid for a few hours.
        </p>

        <p>
          You can request a new link <Link to="/forgot_password">here</Link>.
        </p>

        <p>
          If the problem persist, please
          {' '}
          <Link href={LinkConstants.CONTACT_FORM} target="_blank">contact us</Link>.
        </p>
      </div>
    );
  };

  renderPending = () => {
    return (
      <Form
        onValid={this.enableButton}
        onValidSubmit={this.submit}
        onInvalid={this.disableButton}>
        <Fieldset className="ResetPasswordPage-fieldset" legend="Change your password">
          <FormInput
            label="New password"
            required
            type="password"
            autoComplete="new-password"
            className="ResetPasswordPage-Password"
            name="password"
            validations="minLength:6"
            validOnPristine={false}
            validationError="Password must be at least 6 characters long."
          />
          <FormInput
            label="New password confirmation"
            required
            type="password"
            autoComplete="new-password"
            className="ResetPasswordPage-PasswordConfirmation"
            name="password_confirmation"
            validations="equalsField:password"
            validationError="Must be same as password"
            validOnPristine={false}
          />
          <Button
            size="small"
            type="submit"
            className="ResetPasswordPage-Submit"
            disabled={!this.state.canSubmit}
            eventElementName="ResetPasswordPage-Submit">
            Change my password
          </Button>
        </Fieldset>
      </Form>
    );
  };

  render() {
    const body = (this.state.status === STATUS.pending) ?
      this.renderPending() :
      this.renderFailure();

    return (
      <AuthenticationView>
        <div className="ResetPasswordPage">
          {body}
        </div>
      </AuthenticationView>
    );
  }
}

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/auth/components/ResetPasswordPage.jsx